module.exports = __webpack_public_path__ + "img/box-arrow-up-right.6325449d.svg";